import { makeAutoObservable } from 'mobx'

type SimpleStep = 'profile' | 'selfie' | 'full'

export class SimpleForm {
  private _stage: SimpleStep = 'profile'

  constructor() {
    makeAutoObservable(this)
  }

  get stage(): SimpleStep {
    return this._stage
  }

  set stage(value: SimpleStep) {
    this._stage = value
  }
}
